import { PageHeadButtonProps, PageHeadProps } from '../types';

/**
 * Type guard: проверяет, что пропсы кнопок пришли как tuple из двух элементов.
 * Нужен потому, что `Array.isArray` в TS не сужает union `Object | readonly [X, X]`
 * до массивной ветки — приходится явно объявлять предикат.
 * @kind helper
 * @param buttonProps - пропсы кнопок PageHead в ненулевом виде
 * @returns `true`, если `buttonProps` — tuple `[PageHeadButtonProps, PageHeadButtonProps]`
 */
export const isButtonPropsTuple = (
    buttonProps: NonNullable<PageHeadProps['buttonProps']>,
): buttonProps is readonly [PageHeadButtonProps, PageHeadButtonProps] => Array.isArray(buttonProps);
